export default __webpack_public_path__ + "static/media/redação.21a5c91a.png";